export const baseUrl = window.origin === 'http://localhost:3000' ? 'http://localhost:8080' : 'https://meal-planner-api.k8s.wetjens.net';
